// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"522":"d7faea11","718":"9c85084d","787":"0ac2427a"}[chunkId] + ".chunk.js";
};